import { render, staticRenderFns } from "./PayrollBatchUpload.vue?vue&type=template&id=450bbbd0&scoped=true"
import script from "./PayrollBatchUpload.vue?vue&type=script&lang=js"
export * from "./PayrollBatchUpload.vue?vue&type=script&lang=js"
import style0 from "./PayrollBatchUpload.vue?vue&type=style&index=0&id=450bbbd0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450bbbd0",
  null
  
)

export default component.exports